import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectDialComponent } from './direct-dial/direct-dial.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { MatCardModule } from '@angular/material/card';
import { FormlyCoreModule } from 'ng2-app/form-core/formly/formly-core.module';

@NgModule({
  declarations: [
    DirectDialComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyMaterialModule,
  ],
  exports: [
    DirectDialComponent,
  ],
  providers: [
    FormlyModule,
  ]
})
export class DirectDialModule { }
